import ContactForm from '@/pages/home/components/ContactForm';

const MAP_URL =
  'https://www.google.com/maps/search/?api=1&query=550+Hamilton+Ave,+Palo+Alto,+CA+94301,+United+States';

export default function ContactPanel() {
  return (
    <section className="panel" data-side="left" id="contact" aria-labelledby="contact-heading">
      <img
        className="panel-bg"
        src="https://readdy.ai/api/search-image?query=Quiet%20minimalist%20office%20interior%20with%20deep%20forest%20green%20panelled%20walls%2C%20warm%20oak%20desk%20and%20a%20single%20brass%20desk%20lamp%2C%20soft%20afternoon%20light%20falling%20across%20a%20pale%20stone%20floor%2C%20empty%20and%20composed%2C%20dark%20moody%20architectural%20photography%2C%20no%20people%2C%20editorial%20and%20restrained&width=2400&height=1350&seq=reve-contact-room&orientation=landscape"
        alt="A quiet panelled room with a warm oak desk, lit by soft afternoon light."
        width="2400"
        height="1350"
        loading="eager"
        fetchPriority="low"
        decoding="async"
        data-parallax="0.32"
      />
      <div className="panel-veil" aria-hidden="true" />

      <div className="contact-grid">
        <div className="panel-copy contact-aside" data-parallax="-0.08">
          <p className="stamp" data-reveal>
            06 — Contact
          </p>
          <h2 id="contact-heading" data-reveal>
            Connect with
            <br />
            The Reve <em className="accent">Foundation.</em>
          </h2>
          <p className="sub" data-reveal>
            For enquiries, correspondence or simply to introduce yourself, our foundation contact
            would be glad to hear from you.
          </p>

          <div className="contact-card" data-reveal>
            <p className="person">Sherri Davis</p>
            <p className="role">Foundation Contact</p>

            <div className="row">
              <i className="ri-mail-line" aria-hidden="true" />
              <span>
                <a href="mailto:sherri@therevefoundation.com">sherri@therevefoundation.com</a>
              </span>
            </div>

            <div className="row">
              <i className="ri-map-pin-line" aria-hidden="true" />
              <span>
                <a href={MAP_URL} target="_blank" rel="noopener noreferrer">
                  550 Hamilton Ave
                  <br />
                  Palo Alto, CA 94301
                  <br />
                  United States
                </a>
              </span>
            </div>

            <p className="mail-note">
              Correspondence is by email or post. If the form below is unavailable, please write to us
              directly at the address above.
            </p>
          </div>
        </div>

        <div data-reveal>
          <ContactForm />
        </div>
      </div>
    </section>
  );
}